import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    const carId = this.element.getAttribute("data-car");
    this.glideItem = new Glide(`.glide-${carId}`, {
      rewind: false,
      type: 'carousel',
      gap: 0
    }).mount()
  }

  disconnect() {
    this.glideItem.destroy()
  }
}